import { useIdleLogout } from "./useIdleLogout";

export default function SessionManager() {
  useIdleLogout();

  return null;
}